/**
 * 跨企业搜人 + 发起加好友。
 * 搜人走 Nexora；加好友走 props.onAddFriend(openim_user_id)。
 */
import { useState } from "react";
import { Button, Flex, Input, List, Typography, message } from "antd";
import { searchDirectoryUsers } from "../api/directory";
import type { DirectoryUser } from "../types";

type Props = {
  disabled?: boolean;
  onAddFriend: (openImUserId: string, reqMsg?: string) => Promise<void>;
};

export function DirectorySearch({ disabled, onAddFriend }: Props) {
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState<DirectoryUser[]>([]);
  const [reqMsg, setReqMsg] = useState("你好，加个好友");

  const doSearch = async () => {
    const keyword = q.trim();
    if (!keyword) {
      message.warning("请输入用户名关键字");
      return;
    }
    setLoading(true);
    try {
      setItems(await searchDirectoryUsers(keyword));
    } catch (e) {
      message.error(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex vertical gap={8}>
      <Typography.Text type="secondary">
        跨企业搜人（不隔离租户）。加好友用 OpenIM ID，不是裸用户名。
      </Typography.Text>
      <Flex gap={8}>
        <Input
          placeholder="用户名关键字，如 admin"
          value={q}
          disabled={disabled || loading}
          onChange={(e) => setQ(e.target.value)}
          onPressEnter={() => void doSearch()}
        />
        <Button type="primary" loading={loading} disabled={disabled} onClick={() => void doSearch()}>
          搜索
        </Button>
      </Flex>
      <Input
        placeholder="申请附言"
        value={reqMsg}
        disabled={disabled}
        onChange={(e) => setReqMsg(e.target.value)}
      />
      <List
        size="small"
        bordered
        dataSource={items}
        locale={{ emptyText: "无结果" }}
        renderItem={(u) => (
          <List.Item
            actions={[
              <Button
                key="add"
                type="link"
                disabled={disabled}
                onClick={() =>
                  void onAddFriend(u.openim_user_id, reqMsg.trim() || undefined)
                    .then(() => message.success(`已向 ${u.display_label} 发送申请`))
                    .catch((e: Error) => message.error(e.message))
                }
              >
                加好友
              </Button>,
            ]}
          >
            <List.Item.Meta
              title={u.display_label}
              description={`OpenIM: ${u.openim_user_id}`}
            />
          </List.Item>
        )}
      />
    </Flex>
  );
}